module.exports = __webpack_public_path__ + "static/media/fillingBg1.f16142fe.png";